<template>
  <h1><slot></slot></h1>
  <hr />
  <h1 class="small" v-if="subtitle">{{ subtitle }}</h1>
</template>

<script>
export default {
  name: "HeadlineComponent",
  props: ['subtitle']
}
</script>

<style scoped>

</style>